document.addEventListener('DOMContentLoaded', () => {
    //Function to change the active class within variants
    const d4HandleMealVariants = () => {
        const mealVariants = document.querySelectorAll('.d4-customizer-container .d4-meal .d4-meal-variant');
        for(variant of mealVariants) {
            variant.addEventListener('click', (e) => {
                mealVariants.forEach(variant => {
                    if(variant !== e.target) {
                        variant.classList.remove('d4-meal-selected');
                    }
                });

                e.target.classList.add('d4-meal-selected');
                d4HandleVariantChange(e.target.closest('button').dataset.d4variant);
            });
        };
    };

    //Function to find the variant id of selected variant
    const d4HandleVariantChange = (selectedVariant) => {
        const container = document.querySelector('.d4-customizer-container');
        const formId = container.querySelector('form input[name="id"]');
        const formBtn = container.querySelector('form .product-form__submit span');
        const script = document.querySelector('script[id="d4-variants-script"][type="application/ld+json"]');
        const parsedScript = JSON.parse(script.textContent);
        const [{ id }] = parsedScript.filter(values => values.title === selectedVariant);
        const [{ price }] = parsedScript.filter(values => values.title === selectedVariant);
        const [{ available }] = parsedScript.filter(values => values.title === selectedVariant);

        //update form id
        formId.setAttribute('value', id);
        //update window url
        window.history.replaceState({}, '', `${container.dataset.url}?variant=${id}`);
        //update form btn label and value
        const priceString = price.toString();
        const modifiedPrice = parseFloat(priceString.slice(0, -2) + '.' + priceString.slice(-2)).toFixed(2);
        if(available) {
            formBtn.innerText = formBtn.dataset.statusActive + ' $' + modifiedPrice;
            formBtn.removeAttribute('disabled');
        } else {
            formBtn.innerText = formBtn.dataset.statusInactive;
            formBtn.setAttribute('disabled', 'disabled');
        }
    };

    d4HandleMealVariants();
});